import { Typography } from '@material-ui/core'

import {
  PriceClassForRateConnection,
  RateConnectionChannelFieldsType,
  RoomTypeForRateConnection
} from '../../types/rateConnection'
import RenderRowValues from './RenderRowValues'
import useStyles from './styles/PriceClassDistributionPriceClassRow.styles'

interface PriceClassDistributionPriceClassRowProps {
  priceClassData: PriceClassForRateConnection
  roomTypeIndex: number
  ratePlanIndex: number
  channelIndex: number
  priceClassIndex: number
  updatedRateConnectionList: RoomTypeForRateConnection[]
  setUpdatedRateConnectionList: React.Dispatch<
    React.SetStateAction<RoomTypeForRateConnection[]>
  >
  weekendIndexes: number[]
  range: 'TWO_WEEKS' | 'MONTH'
  isPersian: boolean
  selectedMenuFieldInChannelRow: RateConnectionChannelFieldsType
}

const PriceClassDistributionPriceClassRow: React.FC<
  PriceClassDistributionPriceClassRowProps
> = ({
  priceClassData,
  roomTypeIndex,
  ratePlanIndex,
  channelIndex,
  priceClassIndex,
  updatedRateConnectionList,
  setUpdatedRateConnectionList,
  weekendIndexes,
  range,
  isPersian,
  selectedMenuFieldInChannelRow
}) => {
  const classes = useStyles()

  return (
    <div>
      <div
        className={[
          classes.priceClassRow,
          range === 'MONTH' && classes.priceClassRowMonth
        ].join(' ')}>
        <div className={classes.rowNameContainer}>
          <Typography
            variant="h4"
            className={classes.rowName}
            style={isPersian ? { fontFamily: 'IranSans' } : undefined}>
            {priceClassData.name}
          </Typography>{' '}
        </div>
        <span />
        <RenderRowValues
          rowDataPriceClass={priceClassData.dataForEachDate}
          roomTypeIndex={roomTypeIndex}
          ratePlanIndex={ratePlanIndex}
          channelIndex={channelIndex}
          priceClassIndex={priceClassIndex}
          rateMultiplierIndex={0}
          updatedRateConnectionList={updatedRateConnectionList}
          setUpdatedRateConnectionList={setUpdatedRateConnectionList}
          weekendIndexes={weekendIndexes}
          selectedMenuFieldInChannelRow={selectedMenuFieldInChannelRow}
        />
      </div>
    </div>
  )
}

export default PriceClassDistributionPriceClassRow
